module.exports = __webpack_public_path__ + "static/media/real_older_review.56260775.png";